import { lazy, Suspense } from "react";

import { Paths } from "configs";
import { RouteProps } from "react-router-dom";

const SignInPage = lazy(() => import("pages/SignIn"));

export const AuthenticationSuspenseWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => <Suspense fallback={null}>{children}</Suspense>;

export const AuthenticationRoutes: Array<
  RouteProps & {
    useSuspense?: boolean;
  }
> = [
  {
    path: Paths.SignIn,
    useSuspense: true,
    element: <SignInPage />,
  },
];
